import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function GuidePage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('guideH1')} | CSSBuy Spreadsheet`;
  }, [t]);

  const steps = [
    { icon: 'ri-user-add-line', title: t('guideStep1Title'), desc: t('guideStep1Text') },
    { icon: 'ri-search-line', title: t('guideStep2Title'), desc: t('guideStep2Text') },
    { icon: 'ri-camera-line', title: t('guideStep3Title'), desc: t('guideStep3Text') },
    { icon: 'ri-truck-line', title: t('guideStep4Title'), desc: t('guideStep4Text') },
    { icon: 'ri-map-pin-line', title: t('guideStep5Title'), desc: t('guideStep5Text') },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('breadcrumbGuide')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('guideH1')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-10 max-w-3xl">
              {t('guideIntro')}
            </p>

            <div className="space-y-4 mb-10">
              {steps.map((step, index) => (
                <div key={index} className="flex gap-4 bg-background-100 rounded-xl p-5">
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className={`${step.icon} text-primary-600`} style={{ width: 20, height: 20 }} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-950 mb-1">{step.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <h3 className="font-semibold text-foreground-950 mb-4">{t('articleRelated')}</h3>
              <div className="flex flex-wrap gap-3">
                <Link to="/cssbuy-spreadsheet" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('breadcrumbSpreadsheet')}</Link>
                <Link to="/cssbuy-qc" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">QC</Link>
                <Link to="/cssbuy-shipping" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navShipping')}</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}